import cornerstone from 'cornerstone-core';
import cornerstoneTools, { Synchronizer } from 'cornerstone-tools';

import pixelSpacingPanZoomSynchronizer from './pixelSpacingPanZoomSynchronizer';

const scrollToIndex = cornerstoneTools.importInternal('util/scrollToIndex');

function fusionAwarePositionOffsetSynchronizer(
  synchronizer,
  sourceElement,
  targetElement,
  eventData,
  positionDifference
) {
  if (targetElement === sourceElement) return;

  // Non-fusion viewport
  const targetAllStacks = cornerstoneTools.getToolState(targetElement, 'stack');
  if (!targetAllStacks?.data || targetAllStacks.data.length <= 1) {
    return cornerstoneTools.stackImagePositionOffsetSynchronizer(
      synchronizer,
      sourceElement,
      targetElement,
      eventData,
      positionDifference
    );
  }

  // FusionViewport:
  // Base layer first
  cornerstoneTools.stackImagePositionOffsetSynchronizer(
    synchronizer,
    sourceElement,
    targetElement,
    eventData,
    positionDifference
  );

  // Then sync overlay layer
  const rendererData = cornerstoneTools.getToolState(
    targetElement,
    'stackRenderer'
  );
  const renderer = rendererData?.data[0];
  if (!renderer?.findImageFn) return;

  const ctStack = targetAllStacks.data[0];
  const currentCtImageId = ctStack.imageIds[ctStack.currentImageIdIndex];
  // base layer currentImageIdIndex already updated
  const overlayStacks = targetAllStacks.data.slice(1);

  overlayStacks.forEach((imgObj, overlayLayerIndex) => {
    const imageId = renderer.findImageFn(imgObj.imageIds, currentCtImageId);
    const layerIndex = overlayLayerIndex + 1;
    const currentLayerId = renderer.layerIds[layerIndex];

    if (!currentLayerId) return;

    if (imageId) {
      cornerstone.loadAndCacheImage(imageId).then((image) => {
        cornerstone.setLayerImage(targetElement, image, currentLayerId);
        cornerstone.updateImage(targetElement);
      });
    } else {
      cornerstone.setLayerImage(targetElement, undefined, currentLayerId);
      cornerstone.updateImage(targetElement);
    }
  });
}

const scrollSynchronizer = new Synchronizer(
  cornerstone.EVENTS.NEW_IMAGE,
  fusionAwarePositionOffsetSynchronizer
);

const panZoomSynchronizer = new Synchronizer(
  cornerstone.EVENTS.IMAGE_RENDERED,
  pixelSpacingPanZoomSynchronizer
);

const wwwcSynchronizer = new Synchronizer(
  cornerstone.EVENTS.IMAGE_RENDERED,
  cornerstoneTools.wwwcSynchronizer
);

export { scrollSynchronizer, panZoomSynchronizer, wwwcSynchronizer };
